import * as React from "react";

const SvgAnotherShortcut = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      fillRule="evenodd"
      d="M11.675 18.013q.225.912.65 1.737a8.75 8.75 0 0 1-2.812-3Q8.45 14.9 8.45 12.625q0-1.9.775-3.525A8.9 8.9 0 0 1 11.3 6.3L9 4h8v8l-2.3-2.3a8 8 0 0 0-2.375 2.763q-.875 1.662-.875 3.662 0 .976.225 1.887"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAnotherShortcut;
